import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ContentSend from 'material-ui/svg-icons/content/send';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import Dialog from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import DatePicker from 'material-ui/DatePicker'
import TimePicker from 'material-ui/TimePicker'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import areIntlLocalesSupported from 'intl-locales-supported';

import Hearing from 'material-ui/svg-icons/av/hearing';
import AppBar from 'material-ui/AppBar';

import MailPreview from './MailPreview'
import { FormattedMessage, intlShape } from 'react-intl';

const localeMessages = {
  appointment: {
    id: 'Supporter.AppointmentForm.Appointment',
    defaultMessage: 'Ihr Online-Termin mit {name}'
  },
  clickchat: {
    id: 'Supporter.AppointmentForm.ClickChat',
    defaultMessage: 'Zum chatten hier klicken: '
  },
  startchat: {
    id: 'Supporter.AppointmentForm.StartChat',
    defaultMessage: 'Chat starten'
  },
  chatlink: {
    id: 'Supporter.AppointmentForm.Chatlink',
    defaultMessage: 'Ihr Chatlink auf Nextcare'
  },
  cancel: {
    id: 'Supporter.AppointmentForm.Cancel',
    defaultMessage: 'Abbrechen'
  },
  sendinvite: {
    id: 'Supporter.AppointmentForm.SendInvite',
    defaultMessage: 'Einladung senden'
  },
  sendtoself: {
    id: 'Supporter.AppointmentForm.SendToSelf',
    defaultMessage: 'Link an meine E-Mail-Adresse senden'
  },
  chatlinktitle: {
    id: 'Supporter.AppointmentForm.ChatlinkTitle',
    defaultMessage: 'Sie sind unter folgendem Link erreichbar:'
  },
  chatlinkwithappointment: {
    id: 'Supporter.AppointmentForm.ChatlinkWithAppointment',
    defaultMessage: 'Link mit Termin generieren:'
  },
  choosedate: {
    id: 'Supporter.AppointmentForm.ChooseDate',
    defaultMessage: 'Wählen Sie ein Datum'
  },
  choosetime: {
    id: 'Supporter.AppointmentForm.ChooseTime',
    defaultMessage: 'Wählen Sie eine Uhrzeit'
  },
  ok: {
    id: 'Supporter.AppointmentForm.OK',
    defaultMessage: 'OK'
  },
  sendinvitemail: {
    id: 'Supporter.AppointmentForm.SendInviteMail',
    defaultMessage: 'Einladung versenden'
  },
  mailrecipient: {
    id: 'Supporter.AppointmentForm.MailRecipient',
    defaultMessage: 'Empfänger'
  },
  mailsubject: {
    id: 'Supporter.AppointmentForm.MailSubject',
    defaultMessage: 'Betreff'
  },
  mailremarks: {
    id: 'Supporter.AppointmentForm.MailRemarks',
    defaultMessage: 'Spezielle Anmerkungen'
  },
  mailpreview: {
    id: 'Supporter.AppointmentForm.MailPreview',
    defaultMessage: 'E-Mail Vorschau'
  }
}

class AppointmentForm extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  dateTimeFormat = null;

  constructor(props) {
    super(props);
    this.state = {
      inviteOpen: false,
      invite: {
        message: '',
        subject: '',
        from: '',
        to: ''
      },
      appDate: null,
      appTime: null
    }
  }

  componentWillMount() {
    if (areIntlLocalesSupported([this.props.locale])) {
      this.dateTimeFormat = global.Intl.DateTimeFormat;
    } else {
      const IntlPolyfill = require('intl');
      this.dateTimeFormat = IntlPolyfill.DateTimeFormat;
      require('intl/locale-data/jsonp/de');
      require('intl/locale-data/jsonp/fr');
      require('intl/locale-data/jsonp/it');
    }
  }

  openInviteDialog = () => {
    this.setState({
      inviteOpen: true,
      invite: {
        message: '',
        subject: "[" + this.props.labels.title + "] " + this.context.intl.formatMessage(localeMessages.appointment, {name: this.props.user.name}),
        to: this.props.contact.name + " <" + this.props.contact.email + ">",
        from: this.props.labels.title + ' <' + this.props.mailsender + '>'
      }
    });
  }

  closeInviteDialog = () => {
    this.setState({
      inviteOpen: false
    });
  }

  getInviteText() {
    return `
      {this.state.invite.message}

      ${this.context.intl.formatMessage(localeMessages.clickchat)} ${this.getInviteLink()}
      
      ${this.props.mailfooter}
      </div>
    </div>
    `
  }

  getAppointmentLink() {
    var d = this.state.appDate ? this.state.appDate : new Date();
    var t = this.state.appTime ? this.state.appTime : new Date();
    d.setHours(t.getHours());
    d.setMinutes(t.getMinutes());
    d.setSeconds(t.getSeconds());

    return this.getInviteLink(d);
  }

  getInviteHtml() {
    return (
      <MuiThemeProvider muiTheme={this.props.mailTheme}>
        <div>
          <AppBar
            title={this.props.labels.title}
            iconElementLeft={<Hearing style={{transform: 'translateY(11px)', marginLeft:'10px'}} color="white" />}
          />
          <div className="message" style={{textAlign: 'center', padding: '10px'}}>
            <p style={{whiteSpace: 'pre-line'}}>
              {this.state.invite.message}
            </p>
            <RaisedButton
              href={this.getInviteLink()}
              target="_blank"
              label={this.context.intl.formatMessage(localeMessages.startchat)}
              primary={true}
            />
          </div>
          <div className="footer" style={{paddingTop: '15px', marginTop: '15px', borderTop: '1px solid #ccc'}}>
            {this.state.mailfooter}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }

  sendInvite = () => {
    var div = document.createElement('div');
    ReactDOM.render(this.getInviteHtml(), div);

    var maildata = {
      from: this.state.invite.from,
      to: this.state.invite.to,
      subject: this.state.invite.subject,
      text: this.getInviteText(),
      html: div.innerHTML
    };

    this.props.sendMail(maildata);
  }

  handleInviteField(field, e) {
    const invite = this.state.invite;
    invite[field] = e.target.value;

    this.setState({
      invite: invite
    });
  }

  getInviteLink(appointment) {
    const host = window.location.host.split('.');
    host[0] = this.props.clientprefix;
    
    return window.location.protocol + '//' + host.join('.') + '?u=' + this.props.user.id + (appointment ? '&a=' + appointment.getTime() : '');
  }

  sendInviteToUser(withAppointment) {
    var maildata = {
      from: "MediService Nextcare <noreply@nextcare.io>",
      to: this.props.user.email,
      subject: this.context.intl.formatMessage(localeMessages.chatlink),
      text: withAppointment ? this.getAppointmentLink() : this.getInviteLink()
    };

    this.props.sendMail(maildata);
  }

  render() {
    const actions = [
      <FlatButton
        label={this.context.intl.formatMessage(localeMessages.cancel)}
        primary={true}
        onClick={this.closeInviteDialog}
      />,
      <RaisedButton
        onClick={() => { this.sendInvite(); this.closeInviteDialog(); }}
        label={this.context.intl.formatMessage(localeMessages.sendinvite)}
        primary={true}
        icon={<ContentSend />}
      />
    ];

    return (
      <div>
        <div style={{maxWidth: '40em', margin:'auto'}}>
          <p>
            <FormattedMessage
              id="Supporter.AppointmentForm.ChatlinkTitle"
              defaultMessage="Sie sind unter folgendem Link erreichbar:"
            />
          </p>
          <TextField
            name="invitelink"
            value={this.getInviteLink()}
            onClick={(e) => e.target.select()}
            fullWidth={true}
            inputStyle={{textAlign:'center'}}
          />
          <br/><br/>
          <RaisedButton
            onClick={() => this.sendInviteToUser()}
            label={this.context.intl.formatMessage(localeMessages.sendtoself)}
            primary={true}
            icon={<ContentSend />}
          />
        </div>
        <br/>
        <br/>
        <Divider />
        <br/>
        <br/>
        <div style={{maxWidth: '40em', margin:'auto'}}>
          <p>
            <FormattedMessage
              id="Supporter.AppointmentForm.ChatlinkWithAppointment"
              defaultMessage="Link mit Termin generieren:"
            />
          </p>
          <DatePicker
            locale={this.props.locale}
            onChange={(e, d) => this.setState({appDate: d})}
            DateTimeFormat={this.dateTimeFormat}
            okLabel={this.context.intl.formatMessage(localeMessages.ok)}
            cancelLabel={this.context.intl.formatMessage(localeMessages.cancel)}
            value={this.state.appDate}
            textFieldStyle={{textAlign:'center'}}
            hintText={this.context.intl.formatMessage(localeMessages.choosedate)} />
          <TimePicker
            format="24hr"
            okLabel={this.context.intl.formatMessage(localeMessages.ok)}
            cancelLabel={this.context.intl.formatMessage(localeMessages.cancel)}
            onChange={(e, d) => this.setState({appTime: d})}
            value={this.state.appTime}
            textFieldStyle={{textAlign:'center'}}
            hintText={this.context.intl.formatMessage(localeMessages.choosetime)} />
          <p>
            <FormattedMessage
              id="Supporter.AppointmentForm.YourLink"
              defaultMessage="Ihr Link:"
            />
          </p>
          <TextField
            name="invitelink"
            value={this.getAppointmentLink()}
            onClick={(e) => e.target.select()}
            fullWidth={true}
            inputStyle={{textAlign:'center'}}
          />
          <br/><br/>
          <RaisedButton
            onClick={() => this.sendInviteToUser(true)}
            label={this.context.intl.formatMessage(localeMessages.sendtoself)}
            primary={true}
            icon={<ContentSend />}
          />
        </div>
        <Dialog
          title={this.context.intl.formatMessage(localeMessages.sendinvite)}
          actions={actions}
          modal={false}
          open={this.state.inviteOpen}
          onRequestClose={this.closeInviteDialog}
          contentStyle={{width:'80%', maxWidth: '90vw', maxHeight: '90vh', height: 'auto', minWidth: '50vw'}}
        >
          <div>
            <div className="composeInvite">
              <TextField
                name="inviterecipient"
                floatingLabelText={this.context.intl.formatMessage(localeMessages.mailrecipient)}
                value={this.state.invite.to}
                onChange={(e) => this.handleInviteField('to', e)}
                fullWidth={true}
              /><br />
              <TextField
                name="invitesubject"
                floatingLabelText={this.context.intl.formatMessage(localeMessages.mailsubject)}
                value={this.state.invite.subject}
                onChange={(e) => this.handleInviteField('subject', e)}
                fullWidth={true}
              /><br />
              <TextField
                name="invitemessage"
                floatingLabelText={this.context.intl.formatMessage(localeMessages.mailremarks)}
                value={this.state.invite.message}
                fullWidth={true}
                onChange={(e) => this.handleInviteField('message', e)}
                multiLine={true}
                rows={2}
                rowsMax={4}
              />
            </div>
            <div className="invitePreview">
              <Paper zDepth={2} style={{padding:'1px 10px 10px 10px'}}>
                <h4>E-Mail Vorschau</h4>
                <MailPreview
                  subject={this.state.invite.subject}
                  to={this.state.invite.to}
                  body={this.getInviteHtml()}
                  from={this.state.invite.from} />
              </Paper>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
};

export default AppointmentForm;


// WEBPACK FOOTER //
// ./src/AppointmentForm.js